/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_GenderInputs */

const en_field_gender = /** @type {(inputs: Field_GenderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gender`)
};

const es_field_gender = /** @type {(inputs: Field_GenderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Género`)
};

const fr_field_gender = /** @type {(inputs: Field_GenderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genre`)
};

const de_field_gender = /** @type {(inputs: Field_GenderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geschlecht`)
};

const ja_field_gender = /** @type {(inputs: Field_GenderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`性別`)
};

const zh_field_gender = /** @type {(inputs: Field_GenderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`性别`)
};

const ar_field_gender = /** @type {(inputs: Field_GenderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الجنس`)
};

const id_field_gender = /** @type {(inputs: Field_GenderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gender`)
};

const it_field_gender = /** @type {(inputs: Field_GenderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genere`)
};

const ru_field_gender = /** @type {(inputs: Field_GenderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пол`)
};

const pt_field_gender = /** @type {(inputs: Field_GenderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gênero`)
};

const ko_field_gender = /** @type {(inputs: Field_GenderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`성별`)
};

/**
* | output |
* | --- |
* | "Gender" |
*
* @param {Field_GenderInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const field_gender = /** @type {((inputs?: Field_GenderInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_GenderInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_gender(inputs)
	if (locale === "es") return es_field_gender(inputs)
	if (locale === "fr") return fr_field_gender(inputs)
	if (locale === "de") return de_field_gender(inputs)
	if (locale === "ja") return ja_field_gender(inputs)
	if (locale === "zh") return zh_field_gender(inputs)
	if (locale === "ar") return ar_field_gender(inputs)
	if (locale === "id") return id_field_gender(inputs)
	if (locale === "it") return it_field_gender(inputs)
	if (locale === "ru") return ru_field_gender(inputs)
	if (locale === "pt") return pt_field_gender(inputs)
	return ko_field_gender(inputs)
});